$(document).ready(() => {
  availableButton = $("#available_projects");
  financedButton = $("#financed_projects");
  noProjectsText = $("#noProjectsText");
  noProjectsFinanced = $("#noProjectsFinanced");

  availableButton.on("click", function(){
    $(this).removeClass("btn-outline-secondary");
    $(this).addClass("btn-secondary");
    financedButton.removeClass("btn-secondary");
    financedButton.addClass("btn-outline-secondary");
  })

  financedButton.on("click", function(){
    $(this).removeClass("btn-outline-secondary");
    $(this).addClass("btn-secondary");
    availableButton.removeClass("btn-secondary");
    availableButton.addClass("btn-outline-secondary");
    noProjectsText.addClass("d-none");
    noProjectsFinanced.removeClass("d-none");
  })
})
